import http from "../../http-common";

const handle = (promise) =>
  promise.then((response) => response.data).catch((error) => {
    throw error.response?.data || error.response || error;
  });

const createCampaignApi = (base) => ({
  setup: () => handle(http.get(`${base}/setup`)),
  list: () => handle(http.get(base)),
  searchParties: (params) => handle(http.get(`${base}/parties`, { params })),
  create: (data) => handle(http.post(base, data)),
  get: (id) => handle(http.get(`${base}/${id}`)),
  update: (id, data) => handle(http.patch(`${base}/${id}`, data)),
  submit: (id) => handle(http.post(`${base}/${id}/submit`)),
  start: (id) => handle(http.post(`${base}/${id}/start`)),
  report: (id) => handle(http.get(`${base}/${id}/report`)),
  audience: (id, data) => handle(http.post(`${base}/${id}/audience`, data)),
  recipients: (id, params) => handle(http.get(`${base}/${id}/recipients`, { params })),
  upload: (file) => {
    const form = new FormData();
    form.append("file", file);
    return handle(
      http.post(`${base}/image`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      })
    );
  },
});

export const companyCampaigns = createCampaignApi("/admin/campaigns");
export const ultimateCampaigns = createCampaignApi("/ultimate/campaigns");

export const campaignApi = (scope) =>
  scope === "ultimate" ? ultimateCampaigns : companyCampaigns;

export const campaignStatusLabel = {
  DRAFT: "Rascunho",
  PROCESSING: "Processando",
  COMPLETED: "Concluída",
};

export const templateStatusLabel = {
  DRAFT: "Rascunho",
  PENDING: "Em análise",
  APPROVED: "Aprovado",
  DENIED: "Recusado",
};
